import React from 'react';
import { useQueryClient } from 'react-query';
import { Chunk } from '../types';
import { Checkpoint } from '@magoosh/gre/organisms/checkpoints/types';
import { useQueries } from '@magoosh/gre/app/queries';

import CompletedTab from './completed_tab';
import ToDoTab from './to_do_tab';
import CheckpointsTab from '../checkpoints_tab';

interface Props {
  adaptiveHoursPerChunk: number;
  checkpoints: Checkpoint[];
  prioritizedCheckpoint: React.ReactNode;
  studyPlanIsPresent: boolean;
  tab: 'done' | 'plan';
}

const AdaptivePlan:React.FC<Props> = (props) => {
  const queryClient = useQueryClient();
  const q = useQueries();

  const completedStudyPlanItemsQuery = q.completedStudyPlanItemsQuery({
    enabled: props.studyPlanIsPresent
  });
  
  const studyPlanChunksQuery = q.studyPlanChunksQuery(() => {
    const chunkCount = currentChunkCount();

    if (chunkCount > 0) {
      return { numberOfChunks: chunkCount, startingAt: 0 }
    } else {
      return { numberOfChunks: 1, startingAt: 0 }
    }
  }, { enabled: props.studyPlanIsPresent });

  const fetchMoreChunks = () => {
    return q.fetchMoreChunks.mutate({
      numberOfChunks: 1,
      startingAt: currentChunkCount()
    });
  };

  const setAdaptiveHoursPerChunk = (hours: number) => {
    return q.setAdaptiveHoursPerChunkMutation.mutate(hours);
  };

  const currentChunkCount = () => (queryClient.getQueryData('studyPlanChunks') as Chunk[] || []).length

  if (props.tab === 'plan') {
    return (
      <ToDoTab
        adaptiveHoursPerChunk={props.adaptiveHoursPerChunk}
        chunks={studyPlanChunksQuery?.data}
        fetchMoreChunks={fetchMoreChunks}
        isLoading={studyPlanChunksQuery.isLoading}
        isLoadingMoreChunks={q.fetchMoreChunks.isLoading}
        prioritizedCheckpoint={props.prioritizedCheckpoint}
        setAdaptiveHoursPerChunk={setAdaptiveHoursPerChunk}
        studyPlanIsPresent={props.studyPlanIsPresent}
      />
    );
  } else if (props.tab === 'done') {
    return (
      <CompletedTab
        isLoading={completedStudyPlanItemsQuery.isLoading}
        items={completedStudyPlanItemsQuery.data}
      />
    );
  } else if (props.tab === 'checkpoints') {
    return (
      <CheckpointsTab checkpoints={props.checkpoints} />
    )
  }
}

export default AdaptivePlan;
